import React, { FC } from "react";
import { useSelector } from "react-redux";

import { LineSelection } from "./LineSelection";
import { PointSelection } from "./PointSelection";
import { CircleSelection } from "./CircleSelection";
import { RectSelection } from "./RectSelection";
import { PolygonSelection } from "./PolygonSelection";
import { RouteSelection } from "./RouteSelection";

import { useGeometrySelection } from "../../../../../hooks/geometrySelection/useGeometrySelection";
import { useBufferFeatures } from "./hooks/useBufferFeatures";
import { getGeometryEditor } from "../../../../../ducks/geometryEditor/selectors";
import { getMeasurerState } from "../../../../../ducks/measurer/selectors";

import { GeometrySelectionTypes } from "../types";

export const Selection: FC = () => {
  const [{ type, active, currentTool }] = useGeometrySelection();
  const { active: geometryEditorActive } = useSelector(getGeometryEditor);
  const measurerActive = useSelector(getMeasurerState);

  useBufferFeatures();

  if (!active || geometryEditorActive || measurerActive) {
    return null;
  }

  switch (type) {
    case GeometrySelectionTypes.Point:
      return <PointSelection mode={currentTool} />;
    case GeometrySelectionTypes.Line:
      return <LineSelection mode={currentTool} />;
    case GeometrySelectionTypes.Circle:
      return <CircleSelection mode={currentTool} />;
    case GeometrySelectionTypes.Rect:
      return <RectSelection mode={currentTool} />;
    case GeometrySelectionTypes.Polygon:
      return <PolygonSelection mode={currentTool} />;
    case GeometrySelectionTypes.Route:
      return <RouteSelection mode={currentTool} />;
    default:
      return null;
  }
};
